<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<p class="ded1"><em class="italic">This book is dedicated to Gerard, whose love and encouragement gave me the space to write it.</em></p>
<p class="ded2"><em class="italic">And to the Royal History Geeks community, whose clicks, likes, shares and comments made it possible.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_author.vue?5e73aecf